import styled from 'styled-components'

export const Wrapper = styled.div`
  > button {
    appearance: none;
    background: ${props => props.theme.palette.general.light};
    border: none;
    padding: 5px;
    display: inline-flex;

    &:focus {
      outline: none;
    }

    &.menu-open {
      box-shadow: ${props => props.theme.palette.general.boxShadow};
      padding: 12px 6px;
    }

    svg {
      pointer-events: none;
    }
  }
`
